import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-snapshot-minor-release',
  imports: [],
  templateUrl: './snapshot-minor-release.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './snapshot-minor-release.component.scss',
})
export class SnapshotMinorReleaseComponent {
  @Output() public minorSelected = new EventEmitter<number>();

  public onMinorChanged(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value) {
      const minor = +inputElement.value;
      this.minorSelected.emit(minor);
    }
  }
}
